import classNames from "classnames";
import { Lock, Unlock } from "lucide-react";

type ToggleLockSize = "sm" | "md";

interface ToggleLockProps {
  locked: boolean;
  onLockToggle?: () => void;
  className?: string;
  disabled?: boolean;
  size?: ToggleLockSize;
}

const sizeClasses: Record<ToggleLockSize, { button: string; icon: string }> = {
  sm: { button: "h-5 w-5", icon: "h-3 w-3" },
  md: { button: "h-6 w-6", icon: "h-3.5 w-3.5" },
};

export const ToggleLock = ({
  locked,
  onLockToggle,
  className,
  disabled,
  size = "md",
}: ToggleLockProps) => {
  const Icon = locked ? Lock : Unlock;
  const { button: buttonSize, icon: iconSize } = sizeClasses[size];

  return (
    <button
      type="button"
      className={classNames(
        "inline-flex shrink-0 items-center justify-center rounded-full border transition-colors",
        buttonSize,
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30",
        locked
          ? "border-primary/45 bg-primary/15 text-primary"
          : "border-border bg-muted/50 text-muted-foreground hover:border-border hover:text-foreground/80",
        {
          "opacity-50 cursor-not-allowed": disabled,
        },
        className
      )}
      onClick={onLockToggle}
      disabled={disabled || !onLockToggle}
      aria-pressed={locked}
      aria-label={locked ? "Unlock" : "Lock"}
    >
      <Icon className={iconSize} strokeWidth={2} aria-hidden />
    </button>
  );
};
